export default __webpack_public_path__ + "static/media/aircraft.3589bc84.png";